export enum MembershipStateEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}